// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import StyledIcon from "components/global/StyledIcon/StyledIcon";
import { ReactComponent as PlaySolidIcon } from "resources/icons/solid/play-solid.svg";
import { ReactComponent as RedoAltIcon } from "resources/icons/solid/redo-alt.svg";

// ##################################

const StyledPlayButton = styled.button`
	display: flex;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 2;

	${({ zIndex }) =>
		zIndex &&
		css`
			z-index: ${zIndex};
		`}
`;

// ##################################

const BigPlayRepeatButton = ({
	isEnded,
	onClick,
	zIndex,
	iconSize = "modal_video_center",
}) => (
	<StyledPlayButton
		type="button"
		onClick={onClick}
		label="Start"
		zIndex={zIndex}
	>
		{isEnded ? (
			<StyledIcon relative mirror size={iconSize} noBackground>
				<RedoAltIcon />
			</StyledIcon>
		) : (
			<StyledIcon relative size={iconSize} noBackground>
				<PlaySolidIcon />
			</StyledIcon>
		)}
	</StyledPlayButton>
);

export default BigPlayRepeatButton;
